import Vue from 'vue';
import vuetify from "./plugins/vuetify";
import './plugins/axios'
import App from './App.vue';
import router from './router';
import {defaultLocale, messages} from "@/i18n";
import VueI18n from "vue-i18n";
import VueCompositionAPI from '@vue/composition-api';
import { useProvider } from '@/context';
import store from "./store";
import ICS from 'vue-ics';


Vue.config.productionTip = false

const i18n = new VueI18n({
  messages,
  locale: defaultLocale,
  fallbackLocale: defaultLocale
});

Vue.use(VueCompositionAPI)
Vue.use(ICS)

Vue.mixin({
  methods: {
    formatDate(dateStr) {
      dateStr = dateStr.split("-");
      if (dateStr.length != 3) return "";
      return dateStr[2] + "." + dateStr[1] + "." + dateStr[0];
    },
    formatFormat(formatStr: string): string {
      if (formatStr == 'ONLINE') {
        return 'online';
      } else if (formatStr == 'PRESENCE') {
        return 'präsenz';
      } else return '';
    }
  }
})

new Vue({
  vuetify,
  router,
  store,
  i18n,
  setup() {
    useProvider();
    return {};
  },
  render: h => h(App)
}).$mount('#app')

